import { Node, mergeAttributes } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import debugFactory from "debug";
import { TeamingTiptapExtensionType } from "@teaming/common-enums";
import TeamingTiptapTopic from "./TeamingTiptapTopic.vue";
const debug = debugFactory( "teaming:tiptap:topic" );

export default Node.create( {
	name: "teaming-topic",
	content: "text*",
	defining: true,
	group: "block",
	marks: "",
	draggable: true,

	addNodeView() {
		debug( "Executing addNodeView" );
		// eslint-disable-next-line new-cap
		return VueNodeViewRenderer( TeamingTiptapTopic );
	},

	addOptions() {
		return {
			userName: null,
			onTeamingExtensionCallback: () => {},
		};
	},

	addAttributes() {
		return {
			"suggested-topic-id": {
				default: null,
				keepOnSplit: false,
			},
			"creator-name": {
				default: this.options.userName,
				keepOnSplit: false,
			},
			"is-reviewed": {
				default: "0",
				keepOnSplit: false,
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: "teaming-topic",
			},
		];
	},

	renderHTML( { HTMLAttributes, } ) {
		return [ "teaming-topic", mergeAttributes( HTMLAttributes ), 0, ];
	},

	addCommands() {
		debug( "Executing addCommands" );
		return {
			setTopic: () => ( { commands, } ) => {
				return commands.setNode( this.name );
			},
			toggleTopic: attributes => ( { commands, } ) => {
				return commands.toggleNode( this.name, "paragraph", attributes );
			},
			unsetTopic: () => ( { commands, } ) => {
				return commands.lift( this.name );
			},
		};
	},

	onCreate() {
		const { $anchor, } = this.editor.state.selection;
		if ( $anchor.parent.type.name === this.name ) {
			this.options.onTeamingExtensionCallback( { extension: this.name, type: "create", } );
		}
	},

	onUpdate() {
		const { $anchor, } = this.editor.state.selection;
		if ( $anchor.parent.type.name === this.name ) {
			this.options.onTeamingExtensionCallback( { nodeType: TeamingTiptapExtensionType.TOPIC, type: "update", } );
		}
	},

} );

